//	Stacked offsets: positives stack upward from zero, negatives downward (never mixed into one bar).

//	values: series × points → stacks[seriesIndex][pointIndex] = {y0, y1} (null for gaps)
export function stackSeries(values) {
	const n = values.length ? Math.max(...values.map((s) => s.length)) : 0;
	const stacks = values.map(() => new Array(n).fill(null));
	for (let p = 0; p < n; p++) {
		let pos = 0;
		let neg = 0;
		for (let s = 0; s < values.length; s++) {
			const v = values[s][p];
			if (typeof v !== "number" || !Number.isFinite(v)) continue;
			if (v >= 0) {
				stacks[s][p] = { y0: pos, y1: pos + v };
				pos += v;
			} else {
				stacks[s][p] = { y0: neg, y1: neg + v };
				neg += v;
			}
		}
	}
	return stacks;
}

export function stackExtent(stacks) {
	let min = Infinity;
	let max = -Infinity;
	for (const series of stacks)
		for (const seg of series) {
			if (!seg) continue;
			min = Math.min(min, seg.y0, seg.y1);
			max = Math.max(max, seg.y0, seg.y1);
		}
	if (min === Infinity) return [0, 0];
	return [min, max];
}

//	per-point totals (for the stacked tooltip "Total" row)
export function stackTotals(values) {
	const n = values.length ? Math.max(...values.map((s) => s.length)) : 0;
	const totals = new Array(n).fill(null);
	for (let p = 0; p < n; p++) {
		let t = null;
		for (const s of values) {
			const v = s[p];
			if (typeof v === "number" && Number.isFinite(v)) t = (t ?? 0) + v;
		}
		totals[p] = t;
	}
	return totals;
}
